export default __webpack_public_path__ + "static/SR France - Non OGM - Note d'information-adf17e6c18f34bf425f3195c17edb557.pdf";